<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="officeForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="city">City</label>
              <input type="text" class="form-control" formControlName="city" id="city" placeholder="City">
            </div>
            <div class="col-md-6 mb-3">
              <label for="address">Address</label>
              <input type="text" class="form-control" formControlName="address" id="address" placeholder="Address">
            </div>
            <div class="col-md-3 mb-3">
              <label for="phone">Phone</label>
              <input type="text" class="form-control" formControlName="phone" id="phone" placeholder="Phone">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4 mb-3">
              <label for="address">Time Zone</label>
              <input type="text" class="form-control" formControlName="timeZone" id="timeZone" placeholder="Time Zone">
            </div>
            <div class="col-md-4 mb-3">
              <label for="zkTecoHost">ZkTeco Host</label>
              <input type="text" class="form-control" formControlName="zkTecoHost" id="zkTecoHost" placeholder="ZkTeco Host">
            </div>
            <div class="col-md-4 mb-3">
              <label for="zkTecoPort">ZkTeco Port</label>
              <input type="text" class="form-control" formControlName="zkTecoPort" id="zkTecoPort" placeholder="ZkTeco Port">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(officeForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
